module.exports = __webpack_public_path__ + "fonts/iconfont.a593202d.woff2";